import { SVGProps } from "react";

type PostDirectMessageIconProps = SVGProps<SVGSVGElement> & {
  badgeCount?: number;
  badgeFill?: string;
};

export default function PostDirectMessageIcon(
  props: PostDirectMessageIconProps,
) {
  const {
    height = 24,
    width = 24,
    stroke = "#292D32",
    badgeCount,
    badgeFill = "#D72F2F",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {badgeCount !== undefined && (
        <>
          <rect x="12" y="12" width="12" height="12" rx="6" fill={badgeFill} />
          <text
            x="18"
            y="20.9"
            fill="white"
            fontFamily="Arial, sans-serif"
            fontSize="8.8"
            fontWeight="700"
            textAnchor="middle"
          >
            {badgeCount}
          </text>
        </>
      )}
    </svg>
  );
}
